import React, { useState, useEffect, useRef } from "react";
import "./style.scss";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  PoetryLounge, cornerSectionOverview
} from "../actions";
import { getRouting, formDataGenerator } from "../../../../../utils/common";
import SocialShare from "../../../general/socials";
import cookie from 'react-cookies';

const Poetrysec = (props) => {
  const {
    PoetryLounge,
    poetryLoungeData,
    cornerOverviewList,
    cornerSectionOverview,
    location: { pathname },
  } = props;

  const [activeSection, setActiveSection] = useState(0);
  const [isdesktop, setIsDesktop] = useState(true);
  const [poetry, setPoetry] = useState();
  const [metaData, setmetaData] = useState();
  const [cornerOverviewTab, setcornerOverviewTab] = useState("");
  const [share, setShare] = useState(false);
  const [cardId, setCardId] = useState(-1);
  const current = pathname.split("/")[3];
  const [searchFilter, setsearchFilter] = useState();

  const [poemitems, setpoemItems] = useState([]);
  useEffect(()=>{
    const title = cookie.load('poemTitle');
    if (title) {
      setpoemItems(title);
    }
    // Remove the cookie
    cookie.remove('poemTitle', { path: '/' });
  },[])
  useEffect(() => {
    const handleWindowSizeChangequick = () => {
      setIsDesktop(window.innerWidth > 992);
    };

    window.addEventListener('resize', handleWindowSizeChangequick);
    handleWindowSizeChangequick();
    return () => {
      window.removeEventListener('resize', handleWindowSizeChangequick);
    };
  }, []);

  useEffect(() => {
    let params = {
      search: searchFilter ? searchFilter : '',
    };
    PoetryLounge(formDataGenerator(params));
  }, [searchFilter]);
  
  useEffect(()=>{
    if(poetryLoungeData && poetryLoungeData.poetryData)
      {
        setPoetry(poetryLoungeData.poetryData);
        poetryLoungeData.poetryData && 
        poetryLoungeData.poetryData.items &&
        poetryLoungeData.poetryData.items.length > 0 &&
        poetryLoungeData.poetryData.items.map((item, index)=>{
          if (item.title === poemitems) {
            setActiveSection(index);
          }
        })
      }
    if(poetryLoungeData && poetryLoungeData.poetryData && poetryLoungeData.poetryData.meta){
      setmetaData(poetryLoungeData.poetryData.meta);
    }
  },[poetryLoungeData]);

  useEffect(() => {
    cornerSectionOverview();
  }, []);

  useEffect(() => {
    if (cornerOverviewList && cornerOverviewList.cornerOverview) {
      setcornerOverviewTab(cornerOverviewList.cornerOverview);
    }
  }, [cornerOverviewList]);

  const handleSidebarClick = (index) => {
    setActiveSection(index);
    window.scrollTo(100, 100);
  };

  const handleNextClick = () => {
    if (activeSection < (poetry?.items?.length - 1)) {
      setActiveSection(activeSection + 1);
    }
    window.scrollTo(100, 100);
  };
  
  const handlePreviousClick = () => {
    if (activeSection > 0) {
      setActiveSection(activeSection - 1);
    }
    window.scrollTo(100, 100);
  };
  const [poetryToggleMob, setpoetryToggleMob] = useState(0);
  const poetrytoggle = (index) => {
    if (poetryToggleMob == index) {
      setpoetryToggleMob(null);
    } else {
      setpoetryToggleMob(index);
    }
  };
  //dropdown start

  const [dropdown, setdropdown] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropDown = () => {
    setdropdown(!dropdown);
  };

  const handleClickOut = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setdropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOut);
    return () => {
      document.removeEventListener("click", handleClickOut);
    };
  }, [dropdown]);

  //dropdown end
  const handleClick = (key) => {
    setCardId(key);
    if (cardId == -1 || cardId === key) setShare((prev) => !prev);
    setShare(true);
  };
  const addTodo = () => {
    setShare(false);
  };
  const handleInputSearchName = (e) => {
    setsearchFilter(e.target.value);
  };

  return (
    <div className="wrapper">
      {metaData && metaData !== null && <Helmet>
        <title>{metaData.title ? metaData.title : ""}</title>
        <meta name="description" content={metaData.description ? metaData.description : ""} />
        <meta name="keywords" content={metaData.keywords ? metaData.keywords : ""} />
        <meta property="og:title" content={metaData.og_title ? metaData.og_title : ""} />
        <meta property="og:description" content={metaData.og_description ? metaData.og_description : ""} />
        <meta property="og:image" content={metaData.og_image ? metaData.og_image : ""} />
        <meta property="og:url" content={metaData.og_url ? metaData.og_url : ""} />
      </Helmet>}
      <section className="aboutHead">
        <div className="container">
          <div className="d-flex dropdowncls" ref={dropdownRef}>
            <div class="dropdown me-auto">
              <div
                id="dropdownMenuLink"
                onClick={toggleDropDown}
              >
                <h1>
                  <span>The Poetry</span> Lounge
                  <img
                    className="ms-2"
                    src="/images/New/redDownArrow.svg"
                    alt=""
                  />
                </h1>
              </div>
              {dropdown && (
                <ul class="dropdown-body" aria-labelledby="dropdownMenuLink">
                  {cornerOverviewTab &&
                    cornerOverviewTab.length > 0 &&
                    cornerOverviewTab.map((over, index) =>
                      over.linkName != "Investor Awareness Program" ? (
                        <li>
                          <a
                            class="dropdown-item fw-bold"
                            href={over.linkName=='Quiz' ? over.linkUrl : over.routeConstant}
                          >
                            {over.linkName}
                          </a>
                        </li>
                      ) : null
                    )}
                </ul>
              )}
            </div>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/learners-corner">Learners’ Corner</a>
                </li>
                <li
                  className="breadcrumb-item active breadcolor"
                  aria-current="page"
                >
                  <a href="/learners-corner/the-reading-room">The Reading Room</a>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      {isdesktop === true &&
        <div className="poetrydiv">
          <div className="d-flex justify-content-between">
            <div className="leftdiv pt-5">
              <div className="row">
                <div className="col-md-11">
                  <div className="input-group mb-3 inputsearch">
                    <span className="input-group-text searchbg" id="basic-addon2">
                      <img src="/images/New/grey-search.svg" />
                    </span>
                    <input
                      type="text"
                      className="form-control ps-0"
                      placeholder="Search by name or keyword"
                      aria-label="Search..."
                      aria-describedby="basic-addon2"
                      onChange={handleInputSearchName}
                      value={searchFilter}
                    />
                  </div>
                </div>
              </div>
              <div className="sidebar">
                {poetry &&
                  poetry.items &&
                  poetry.items.length > 0 &&
                  poetry.items.map((item, index) => {
                    return (
                      <div className="sidetextdiv" key={index}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="23"
                          height="24"
                          viewBox="0 0 23 24"
                          fill="none"
                          className="feather-icon"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M5.31072 10.5836L12.9596 2.93469C14.703 2.41333 17.0223 2.21722 18.7003 3.05622C19.5364 3.47424 20.2316 4.15609 20.6438 5.24341C21.0484 6.31079 21.197 7.81611 20.8606 9.91234L12.7501 18.0229H6.05293L15.5607 8.51516L14.5 7.4545L5.31072 16.6438V10.5836ZM3.81072 18.1438V10.2729V9.96224L4.03039 9.74257L12.0304 1.74257L12.1594 1.61353L12.3333 1.5582C14.2396 0.951664 17.1214 0.589728 19.3711 1.71458C20.5267 2.29239 21.494 3.25429 22.0464 4.71176C22.5916 6.15019 22.7139 8.01914 22.2996 10.4014L22.2589 10.6353L22.091 10.8032L13.591 19.3032L13.3714 19.5229H13.0607H4.56072H4.55293L1.06066 23.0152L0 21.9545L3.81072 18.1438Z"
                            fill={activeSection === index ? "#004B8B" : "#6F6F6F"}
                          />
                        </svg>
                        <a
                          href={`#section${index}`}
                          className={
                            activeSection === index
                              ? "active-scroll-spy sidetext"
                              : "sidetext"
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            handleSidebarClick(index);
                          }}
                        >
                          {item.title ? item.title : ''}
                        </a>
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className="rightdiv mt-5">
              {poetry &&
              poetry.items &&
              poetry.items.length > 0 &&
              poetry.items.map((general, index) =>
                  activeSection === index ? (
                    <section id={`section${index}`} key={index} className="poemdiv">
                      <div className="maintitle">
                        <h1>{general.title ? general.title : ""}</h1>
                        <div className="d-flex align-items-center">
                          <p className="me-2">Share</p>
                          <div className="share" onClick={() => handleClick(index)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                              <path d="M7.69273 8.69518C7.21388 7.73934 6.22528 7.08317 5.08341 7.08317C3.47258 7.08317 2.16675 8.38901 2.16675 9.99984C2.16675 11.6107 3.47258 12.9165 5.08341 12.9165C6.22528 12.9165 7.21388 12.2603 7.69273 11.3045M7.69273 8.69518C7.8894 9.08775 8.00008 9.53087 8.00008 9.99984C8.00008 10.4688 7.8894 10.9119 7.69273 11.3045M7.69273 8.69518L13.3074 5.88783M7.69273 11.3045L13.3074 14.1118M13.3074 5.88783C13.7863 6.84367 14.7749 7.49984 15.9167 7.49984C17.5276 7.49984 18.8334 6.194 18.8334 4.58317C18.8334 2.97234 17.5276 1.6665 15.9167 1.6665C14.3059 1.6665 13.0001 2.97234 13.0001 4.58317C13.0001 5.05214 13.1108 5.49526 13.3074 5.88783ZM13.3074 14.1118C13.1108 14.5044 13.0001 14.9475 13.0001 15.4165C13.0001 17.0273 14.3059 18.3332 15.9167 18.3332C17.5276 18.3332 18.8334 17.0273 18.8334 15.4165C18.8334 13.8057 17.5276 12.4998 15.9167 12.4998C14.7749 12.4998 13.7863 13.156 13.3074 14.1118Z" stroke="#004B8B" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                            {share && cardId === index && (
                              <SocialShare
                                fundName={getRouting(
                                  `/${current}`
                                )}
                                addTodo={addTodo}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div
                            className="poem"
                            dangerouslySetInnerHTML={{
                              __html: general.body ? general.body : "",
                            }}
                          />
                        </div>
                        <div className="col-md-6">
                          <img
                            src={general.image && general.image.url ? general.image.url : ""}
                            className="poemimg"
                            alt={general.image && general.image.alt ? general.image.alt : ""}
                          />
                          <div className="nextprev">
                            <button 
                            className={activeSection > 0 ? "cursorp" : "notcursor"}
                            onClick={handlePreviousClick}
                            disabled={!(activeSection > 0)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                className="me-2"
                              >
                                <path
                                  d="M18.6667 9.33301L13.3334 15.9997L18.6667 22.6663"
                                  stroke={activeSection > 0 ? "#004B8B" : "#D6D6D6"}
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                              Previous
                            </button>
                            <button
                              className={activeSection < (poetry?.items?.length - 1) ? "cursorp ms-3" : "notcursor ms-3"}
                              onClick={handleNextClick}
                              disabled={!(activeSection < (poetry?.items?.length - 1))}
                              >
                              Next
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                className="ms-2"
                              >
                                <path
                                  d="M13.3333 22.667L18.6666 16.0003L13.3333 9.33366"
                                  stroke={activeSection < (poetry?.items?.length - 1) ? "#004B8B" : "#D6D6D6"}
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </section>
                  ) : (
                    ""
                  )
                )}
            </div>
          </div>
          <hr className="borderb"></hr>
        </div>
      }
      {isdesktop === false &&
      <div className="container mt-4">
      {poetry &&
       poetry.items && 
       poetry.items.length > 0 &&
       poetry.items.map((item, index)=>{
        return(
        <div className="accordian poetryacord">
          <div className="item">
            <div
              className="title"
              onClick={() => poetrytoggle(index)}
            >
              <div>
                <h2 className={poetryToggleMob == index ? "maintitle":''}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none" className="me-2">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.48556 7.95913L10.4914 1.9533C11.8558 1.55225 13.6324 1.4156 14.9034 2.05109C15.535 2.36689 16.0597 2.88 16.3728 3.70611C16.6788 4.51337 16.7992 5.66554 16.5449 7.28841L10.1799 13.6534H5.29355L12.5838 6.36315L11.5232 5.30249L4.48556 12.3401V7.95913ZM2.98556 13.8401V7.64847V7.33781L3.20523 7.11814L9.56283 0.760536L9.69187 0.631501L9.86576 0.576171C11.3957 0.089389 13.7334 -0.210957 15.5743 0.709449C16.5254 1.18504 17.322 1.97821 17.7754 3.17446C18.2216 4.35166 18.3166 5.8669 17.9844 7.77697L17.9437 8.0109L17.7758 8.1788L11.0208 14.9337L10.8012 15.1534H10.4905H3.79355L1.06066 17.8863L0 16.8256L2.98556 13.8401Z" fill={poetryToggleMob == index ?"#004B8B" : "#6F6F6F"} />
                  </svg>
                {item.title ? item.title : ''}
                </h2>
              </div>
              <div className={poetryToggleMob == index ? "rotate" : "downarrow"}>
                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 1L7 7L1 0.999999" stroke={poetryToggleMob == index ? "#004B8B" : "#231F20"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            <div
              className={
                poetryToggleMob == index
                  ? "content show"
                  : "content"
              }
            >
              <div>
                <div className="d-flex justify-content-between mobshare">
                  <img src={item.image && item.image.url ? item.image.url : ''} className="mobimg mb-4"/>
                  <div className="d-flex">
                    <p className="me-2">Share</p>
                    <div className="share" onClick={() => handleClick(index)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                        <path d="M6.25404 6.95644C5.87096 6.19176 5.08007 5.66683 4.16659 5.66683C2.87792 5.66683 1.83325 6.7115 1.83325 8.00016C1.83325 9.28883 2.87792 10.3335 4.16659 10.3335C5.08007 10.3335 5.87096 9.80856 6.25404 9.04389M6.25404 6.95644C6.41137 7.27049 6.49992 7.62499 6.49992 8.00016C6.49992 8.37534 6.41137 8.72983 6.25404 9.04389M6.25404 6.95644L10.7458 4.71056M6.25404 9.04389L10.7458 11.2898M10.7458 4.71056C11.1289 5.47523 11.9198 6.00016 12.8333 6.00016C14.1219 6.00016 15.1666 4.95549 15.1666 3.66683C15.1666 2.37817 14.1219 1.3335 12.8333 1.3335C11.5446 1.3335 10.4999 2.37817 10.4999 3.66683C10.4999 4.04201 10.5885 4.3965 10.7458 4.71056ZM10.7458 11.2898C10.5885 11.6038 10.4999 11.9583 10.4999 12.3335C10.4999 13.6222 11.5446 14.6668 12.8333 14.6668C14.1219 14.6668 15.1666 13.6222 15.1666 12.3335C15.1666 11.0448 14.1219 10.0002 12.8333 10.0002C11.9198 10.0002 11.1289 10.5251 10.7458 11.2898Z" stroke="#004B8B" stroke-width="1.5" stroke-linecap="round"/>
                      </svg>
                      {share && cardId === index && (
                        <SocialShare
                          fundName={getRouting(
                            `/${current}`
                          )}
                          addTodo={addTodo}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: item.body ? item.body : "",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        )
       })}
      </div>
      }
      <div className="container">
        <div className="disclaimersec mb-5">
          <h2>Disclaimer</h2>
          {poetry && poetry.disclaimer ?
            <div
            dangerouslySetInnerHTML={{
              __html: poetry.disclaimer,
            }}
           />:''
          }
        </div>
      </div>
    </div>
  );
};


const mapStateToProps = (state) => ({
  poetryLoungeData: state.LearnsCorners,
  cornerOverviewList: state.LearnsCorners,
});

const mapDispatchToProps = (dispatch) => ({
  PoetryLounge: bindActionCreators(PoetryLounge, dispatch),
  cornerSectionOverview: bindActionCreators(cornerSectionOverview, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Poetrysec);

